import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { OverlayStyled } from './overlay.styled';
const OverlayStandAloneComponent = ({ dataTestId = 'overlay', ...props }, ref) => {
    return _jsx(OverlayStyled, { ref: ref, "data-testid": dataTestId, styles: props.styles });
};
/**
 * @description
 * Overlay component is used to create a background overlay.
 * @param {React.PropsWithChildren<IOverlayStandAlone>} props
 * @returns {JSX.Element}
 * @constructor
 * @example
 * <Overlay />
 */
export const OverlayStandAlone = React.forwardRef(OverlayStandAloneComponent);
//# sourceMappingURL=overlayStandAlone.js.map